<app-card-auth title="Sign In">
  <app-login-form
    resetLink="/reset-password-form"
    createAccountLink="/sign-up-form"
  ></app-login-form>
</app-card-auth>
